import Service from './Service';

export type {
    IService, IServiceData, IData, IIcon,
} from './types';
export default Service;
